import { Button } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import { OtpField, ResendOtp, useTimer } from '../../../../lib/OtpField';
import { maskMobileNumber } from '../../../../utils/utilityFunctions';
import {
    consolidationFolios,
    verifyChangeEmailOTP as verifyOTP,
    sendPhoneOTP,
} from '../../../../redux-store/actions/nct';
import OtpScreen from './../OtpScreen';
import { RootStateType } from '../../../../redux-store/reducers';
import { OTP_ACTIONS } from '../../../../utils/constants';
import { ActionHeader } from '..';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import OtpSentTextWrapper from '../../../../lib/OtpSentTextWrapper';
const { dashboard } = en;

const initState = {
    otp: null,
    reqId: null,
    otpRef: null,
};

function ConsolidationFoliosOtp(props: any) {
    const {
        mobile = null,
        onSucessNavigationUrl = 'change-mobile-new',
        success = false,
    } = props.location.state || {};
    const [otpInput, setOtp] = useState<any>(new Array(6).fill(''));
    const [count, setCount] = useState(0);
    const [{ otp, reqId, otpRef }, setOtpInfo] = useState(initState);
    const { timer, startTimer, resetTimer } = useTimer({});
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const { otp, reqId, otpRef } = props.location.state || {};
        if (!props.location.state) {
            props.history.push('/');
            return;
        }
        setOtpInfo({
            otp,
            reqId,
            otpRef,
        });
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const { pan, pekrn } = props;
            const payload = {
                enteredOtp: otpInput.join(''),
                otpRef,
                reqId,
                pan,
                pekrn,
                mobile,
                action: OTP_ACTIONS.consolidationFolios,
            };

            await props.verifyOTP(payload);
            updateConsolidationFolios();
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    const updateConsolidationFolios = async () => {
        try {
            const { data, amc } = props.location.state;
            const { pan, pekrn, mobile } = props;
            let res = await props.consolidationFolios({
                data,
                pan,
                amc,
                pekrn,
                reqId,
                mobile,
            });
            props.history.replace('consolidation-folios-success', {
                data: data,
                mobile: mobile,
                ...(res || {}).body,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };

    const onResend = async () => {
        try {
            const { pan, pekrn } = props;
            let payload = {
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.consolidationFolios,
            };

            let res = await props.sendPhoneOTP(payload);
            setShowModal(true);
            setOtpInfo({ ...(res || {}).body });
            setOtp(new Array(6).fill(''));
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.ConsolidationFolios.ConsolidationFoliosHeading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-otp-img.png" alt="icon" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.OtpScreen.subHeading}
                            <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                        </h3>
                        <OtpSentTextWrapper
                            userRegisteredWith={props.userRegisteredWith}
                            mobile={maskMobileNumber(mobile)}
                            email={props.email}
                        />
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setCount(count + 1);
                                setOtp(otp);
                            }}
                            showModal={showModal}
                            _handleProceed={() => setShowModal(false)}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButtonWithLoader
                            disabled={otpInput.join('').length !== 6}
                            loading={loading}
                            label={dashboard.OtpScreen.buttonText}
                            labelWhileLoading={dashboard.OtpScreen.buttonTextWhileLoading}
                            onClick={handleSubmit}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    consolidationFolios,
    verifyOTP,
    sendPhoneOTP,
})(ConsolidationFoliosOtp);
